import React from 'react'
import { CTALink } from '../CTALink'
import { ModalButton } from '../ModalButton'
import { IProps } from './index'
import { SolutionCardWithHeader } from './cards/SolutionCardWithHeader'
import { SolutionCardDefault } from './cards/SolutionCardDefault'
import { SolutionCardCompact } from './cards/SolutionCardCompact'

export function SolutionCard({ title, cta, ...cardProps }: IProps) {
  const ComponentWrapper = ({ cta, ...rest }: any) => {
    if (cta?.url) return <CTALink {...cta} {...rest} />
    if (cta?.modalComponent) return <ModalButton {...cta} {...rest} />
    return <React.Fragment {...rest} />
  }

  const CardComponent = ({ type = 'default', ...props }: IProps) => {
    switch (type) {
      case 'default':
        return <SolutionCardDefault {...props} />
      case 'compact':
        return <SolutionCardCompact {...props} />
      case 'with-header':
        return <SolutionCardWithHeader {...props} />
      default:
        return null
    }
  }

  return (
    <ComponentWrapper cta={cta} key={title}>
      <CardComponent {...cardProps} title={title} cta={cta} />
    </ComponentWrapper>
  )
}
